export const getGreeting = (now: Date): string => {
  const hour = now.getHours();

  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

export const getFirstName = (fullName: string): string =>
  fullName.trim().split(/\s+/)[0] || 'there';
